import { ChangeDetectionStrategy, Component, computed, inject, OnDestroy } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { VenueDetailsService } from '../venue-details.service';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { Subject, takeUntil } from 'rxjs';
import { TranslateModule } from '@ngx-translate/core';
import { PartnerNamePipe } from '../../../_shared/pipes/partner-name.pipe';

@Component({
  selector: 'app-venue-integrations',
  templateUrl: './venue-integrations.component.html',
  styleUrls: ['./venue-integrations.component.scss'],
  standalone: true,
  imports: [
    IonicModule,
    ReactiveFormsModule,
    TranslateModule,
    PartnerNamePipe
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class VenueIntegrationsComponent implements OnDestroy {
  venueDetailsService = inject(VenueDetailsService);

  venue = computed(() =>this.venueDetailsService.venue());

  integrationForm = new FormGroup({
    partner: new FormControl(null, Validators.required),
    token: new FormControl(null, Validators.required)
  })

  isIntegrationsModalOpen = false;
  private readonly destroy$: Subject<void> = new Subject();

  constructor() {
    this.venueDetailsService.venueWithAddedIntegrations$
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        this.isIntegrationsModalOpen = false;
      })

    this.venueDetailsService.venueWithDeletedIntegration$
      .pipe(takeUntil(this.destroy$))
      .subscribe()
  }

  async ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  addIntegration() {
    const partner = this.integrationForm.controls.partner.value;
    const receiverToken = this.integrationForm.controls.token.value;

    if (!partner || !receiverToken) {
      return;
    }

    this.venueDetailsService.addIntegration$.next({
      receiverToken,
      partner,
    });
  }

  deleteIntegrations(_integrationId: string) {
    this.venueDetailsService.deleteIntegration$.next({ _integrationId })
  }

}
